import moment from 'moment';
import globals from '../globals/communityGlobals';

const errors = globals.getArea('error');

const checkRequiredOnBlur = (value, setValidationErrorsCallback, fieldName, validationErrors) => {
  if (!value) {
    setValidationErrorsCallback({ ...validationErrors, [fieldName]: errors.getMsg('requiredFieldValidationMessage') });
  }
};

const getErrorProps = validationErrors => {
  return validationErrors
    ? {
        helperText: validationErrors,
        error: true,
      }
    : null;
};

const combineDateTime = (date, time) => {
  const combined = new Date(date);
  combined.setHours(time.getHours(), time.getMinutes());
  return combined;
};

const checkEndTimeBeforeNow = date => {
  const selectedEndTime = new Date(moment(moment(date).format(globals.dateFormats.localApiFormat)));
  selectedEndTime.setSeconds(0, 0);
  const now = new Date(globals.now);
  now.setSeconds(0, 0);
  return !(selectedEndTime < now);
};

const checkEndTimeAfterNow = date => {
  const selectedEndTime = new Date(moment(moment(date).format(globals.dateFormats.localApiFormat)));
  selectedEndTime.setSeconds(0, 0);
  const now = new Date(globals.now);
  now.setSeconds(0, 0);
  return !(selectedEndTime > now);
};

export { getErrorProps, combineDateTime, checkRequiredOnBlur, checkEndTimeBeforeNow, checkEndTimeAfterNow };
